var p=function(r){return r.PUBLIC="public",r.PRIVATE="private",r}({});export{p as AttendantVisibility};